import React, {useState} from "react";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import {Button} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

export function IconPicker(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deselectAll = () => {
        props.handleFormChange(props.index, "icon",
            {
                deleteAll: true
            }
        )
    }

    return (
        <>
            <Button variant="outline-primary" size="sm" onClick={handleShow} className="mt-3 mb-3">
                Choose icons
            </Button>

            <Modal show={show}
                   scrollable={true}
                   size="lg"
                   onHide={handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Choose icons
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Container>
                        {
                            props.dictionaries.jumpIcons.map((iconGroup, index) => (
                                <IconGroup
                                    key={index}
                                    index={props.index}
                                    iconIDs={props.iconIDs}
                                    iconGroup={iconGroup}
                                    handleFormChange={props.handleFormChange}/>
                            ))
                        }
                        </Container>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={deselectAll}>
                        Deselect all
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export function IconGroup(props) {
    return (
        <>
            <Row>
                <h6 className="mb-3">{props.iconGroup.name}</h6>
            </Row>
            <Row className="icon-negative-margin">
                {
                    props.iconGroup.icons.map((icon, index) => (
                        <PickableIcon key={index} index={props.index} iconIDs={props.iconIDs} icon={icon} handleFormChange={props.handleFormChange} />
                    ))
                }
            </Row>
            <hr/>
        </>
    )
}

export function PickableIcon(props) {
    const iconChosen = props.iconIDs.filter(icon => icon.id === props.icon._id).length > 0;

    const handleChoose = () => {
        if(!iconChosen) {
            props.handleFormChange(props.index, "icon",
                {
                    id: props.icon._id,
                    name: props.icon.name,
                    url: props.icon.iconURL
                }
            )
        } else {
            props.handleFormChange(props.index, "icon",
                {
                    url: props.icon.iconURL,
                    toDelete: true
                }
            )
        }
    }

    return (
        <a className="icon-width px-0" onClick={handleChoose}>
            <div className="text-center">
                <div className="relative-div">
                    <img className="jump-img" alt={props.icon.name} src={props.icon.iconURL}/>
                    {iconChosen
                        ? <>
                            <img className="select-icon" src="selecticon.png" alt="✓"/>
                        </>
                        : <></>}
                </div>
                <p className="mb-0 icon-text">{props.icon.name}</p>
            </div>
        </a>
    );
}

